import { render, staticRenderFns } from "./VariableSummaryChart.vue?vue&type=template&id=05db0b7d&scoped=true"
import script from "./VariableSummaryChart.vue?vue&type=script&lang=js"
export * from "./VariableSummaryChart.vue?vue&type=script&lang=js"
import style0 from "./VariableSummaryChart.vue?vue&type=style&index=0&id=05db0b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db0b7d",
  null
  
)

export default component.exports